import { Alert, Feedback } from '@stone-payments/jade'

import { type KycStatusOnboardingProps } from '../kyc-onboarding.component'

import { KycStatusContainer } from './kyc-status-container'

export const KycStatusRejected = ({ actionButton }: KycStatusOnboardingProps) => {
  return (
    <KycStatusContainer actionButton={actionButton}>
      <Feedback
        variant="negative"
        icon="close"
        title="Não foi possível ativar sua Conta Stone"
        description="Caso tenha dúvidas, saldo a receber ou maquininha em sua empresa, converse com a gente pelos canais de atendimento."
      />
      <Alert
        style={{ marginTop: '1.25rem' }}
        variant="neutral"
        description="Nossos telefones: 3004 9680 (capitais e regiões metropolitanas) ou 0800 326 0506 (demais regiões)."
        showIcon
        icon="headset"
      />
    </KycStatusContainer>
  )
}
